import { motion } from "framer-motion";
import { Experience } from "../../data/experience";

const getYear = (timeframe: string): string => {
  const parts = timeframe.split("-")[0].trim();
  const yearMatch = parts.match(/\d{4}/);
  return yearMatch ? yearMatch[0] : parts;
};

const ExperienceItem = ({
  exp,
  forceAnimate = false,
}: {
  exp: Experience;
  forceAnimate?: boolean;
}) => {
  const year = getYear(exp.timeframe);

  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      animate={forceAnimate ? { opacity: 1, y: 0 } : undefined}
      whileInView={!forceAnimate ? { opacity: 1, y: 0 } : undefined}
      transition={{ duration: 0.6 }}
      viewport={{ once: true, amount: 0.2 }}
      className="relative flex flex-col items-start gap-6 md:flex-row"
    >
      {/* Side Year Label */}
      <div className="absolute top-1 -left-10 text-xs font-semibold text-[color:var(--text-soft)] md:-left-16 md:text-sm">
        {year}
      </div>

      {/* Logo */}
      <div className="z-10 h-20 w-20 overflow-hidden rounded-xl border border-[color:var(--card-border)] bg-[color:var(--surface-strong)] p-2 shadow-sm">
        <img
          src={exp.logo}
          alt={exp.company}
          className="w-full h-full object-contain"
        />
      </div>

      {/* Details */}
      <div className="page-card z-10 flex-1 rounded-2xl p-6 transition hover:-translate-y-1 hover:shadow-[0_20px_44px_rgba(17,35,24,0.14)]">
        <h3 className="section-title mb-1 text-xl font-semibold">
          {exp.title} @ {exp.company}
        </h3>
        <p className="meta-copy mb-3 text-sm font-medium">
          {exp.location} • {exp.timeframe}
        </p>
        <ul className="body-copy list-disc space-y-2 pl-5 text-sm leading-7">
          {exp.bullets.map((point, idx) => (
            <li key={idx}>{point}</li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
};

export default ExperienceItem;
